import {
    IPricingPlanData,
    TActivePlanCode,
    TPlanCode,
    TPricingPeriod,
    TPricingTier
} from '~/components/Membership/types/membership.types';
import { Coupons } from '~/constants/coupons';

export const PRICING_PLANS: Record<TActivePlanCode, IPricingPlanData> = {
    starter_monthly_2023: {
        planCode: 'starter_monthly_2023',
        pricingTierName: 'Starter',
        subtitleKey: 'starter',
        isPopular: false,
        period: 'monthly',
        pricingTier: 'starter',
        pricingTierAnalyticsProp: 'Starter'
    },
    essentials_monthly: {
        planCode: 'essentials_monthly',
        pricingTierName: 'Essentials',
        subtitleKey: 'essentials',
        isPopular: true,
        period: 'monthly',
        benefitsIntroKey: 'essentials',
        pricingTier: 'essentials',
        pricingTierAnalyticsProp: 'Essentials'
    },
    premium_monthly: {
        planCode: 'premium_monthly',
        pricingTierName: 'Premium',
        subtitleKey: 'premium',
        isPopular: false,
        period: 'monthly',
        benefitsIntroKey: 'premium',
        pricingTier: 'premium',
        pricingTierAnalyticsProp: 'Premium'
    },
    starter_annual: {
        planCode: 'starter_annual',
        pricingTierName: 'Starter',
        subtitleKey: 'starter',
        isPopular: false,
        period: 'annual',
        pricingTier: 'starter',
        pricingTierAnalyticsProp: 'Starter'
    },
    essentials_annual: {
        planCode: 'essentials_annual',
        pricingTierName: 'Essentials',
        subtitleKey: 'essentials',
        isPopular: true,
        period: 'annual',
        benefitsIntroKey: 'essentials',
        pricingTier: 'essentials',
        pricingTierAnalyticsProp: 'Essentials'
    },
    premium_annual: {
        planCode: 'premium_annual',
        pricingTierName: 'Premium',
        subtitleKey: 'premium',
        isPopular: false,
        period: 'annual',
        benefitsIntroKey: 'premium',
        pricingTier: 'premium',
        pricingTierAnalyticsProp: 'Premium'
    }
};

type TPlanCodeMonthlyYearlyPair = Partial<Record<TPricingPeriod, TPlanCode>>;

export const pricingTiersPlanCodes: Partial<
    Record<TPricingTier, TPlanCodeMonthlyYearlyPair>
> = {
    starter: {
        monthly: 'starter_monthly_2023',
        annual: 'starter_annual'
    },
    essentials: {
        monthly: 'essentials_monthly',
        annual: 'essentials_annual'
    },
    premium: {
        monthly: 'premium_monthly',
        annual: 'premium_annual'
    }
};

export const DEFAULT_PRICING_PERIOD_VALUE: TPricingPeriod = 'annual';
export const STARTER_PLAN_MAX_EARNINGS = 10_000;

export const DISPLAYED_PRICING_PLANS: Record<
    TPricingPeriod,
    TActivePlanCode[]
> = {
    monthly: ['starter_monthly_2023', 'essentials_monthly', 'premium_monthly'],
    annual: ['starter_annual', 'essentials_annual', 'premium_annual']
};

export const URGENCY_TEST_TIME_ZONE = 'America/Los_Angeles';
export const CYCLE_FIRST_DAY = 1;
export const CYCLE_LAST_DAY = 4;
export const CYCLE_STOP_FIRST_DAY = 5;
export const CYCLE_STOP_LAST_DAY = 0;
export const FIXED_NEW_PRICES_DISCOUNT = 0.8; // 20% discount for all members
export const PRICING_PLAN_CHANGE_DATE = new Date(
    '2025-02-04T00:00:00.000+00:00'
);

export const INELIGIBLE_COUPON_CODES_FOR_SUBSCRIBERS = [
    Coupons.imagen30,
    Coupons.blazeai30,
    Coupons.wppi30,
    Coupons.rella30
];
